import deployEnv from 'environment-paypal';

const getHost = ({
  domain = 'paypal.com',
  stageHostName = 'msmaster.qa.paypal.com'
} = {}) => {
  const contextLocation = { domain, stageHostName };
  return typeof window === 'undefined'
    ? getHostServerSide(contextLocation)
    : getHostClientSide(contextLocation);
};

const getHostClientSide = contextLocation => {
  const { hostname, protocol } = window.location;
  const { stageHostName } = contextLocation;

  return hostname.includes('localhost')
    ? `https://www.${stageHostName}`
    : `${protocol}//${hostname}`;
};

const getHostServerSide = contextLocation => {
  if (deployEnv.isDev() || deployEnv.isStage()) {
    const { stageHostName } = contextLocation;
    return `https://www.${stageHostName}`;
  } else if (deployEnv.isSandbox()) {
    const { domain } = contextLocation;
    return `https://www.sandbox.${domain}`;
  }

  const { domain } = contextLocation;
  return `https://www.${domain}`;
};

export { getHost };
